import {getRequest, postRequest, putRequest, postWithFile} from './api-requests';
import apiConfig from '../../../api-config';

export const Pharmacies = Object.freeze({
    list: () => getRequest(`${apiConfig.base_url}/web/pharmacy/list`),
    listFilter: (data = {}) => {
        let getString = `?isDrugstore=${data.isDrugstore ? 1 : 0}`;
        if (data.sortBy !== undefined) {
            getString += `&sort_by=${data.sortBy}`;
        }
        if (data.offset !== undefined && data.limit !== undefined) {
            getString += `&offset=${data.offset}&limit=${data.limit}`
        }
        if (data.search) {
            getString += `&search=${data.search}`
        }

        return getRequest(`${apiConfig.base_url}/web/pharmacy${getString}`)
    },
    single: id => getRequest(`${apiConfig.base_url}/web/pharmacy/${id}`),
    add: details => postRequest(`${apiConfig.base_url}/web/pharmacy`, details),
    edit: (details, id) => putRequest(`${apiConfig.base_url}/web/pharmacy/${id}`, details),
    uploadPrices: (details, id) => postWithFile(`${apiConfig.base_url}/web/pharmacy/uploadPrices`, details),
    servicesList: pharmacyId => getRequest(`${apiConfig.base_url}/web/pharmacy/${pharmacyId}/services`),
    addService: (details, pharmacyId) => postRequest(`${apiConfig.base_url}/web/pharmacy/${pharmacyId}/services`, details),
    orderListService: (details, pharmacyId, language) => putRequest(`${apiConfig.base_url}/web/pharmacy/${pharmacyId}/services/${language}`, details),
    singleService: (pharmacyId, serviceId) => getRequest(`${apiConfig.base_url}/web/pharmacy/${pharmacyId}/services/${serviceId}`),
    editService: (details, pharmacyId, serviceId) => postRequest(`${apiConfig.base_url}/web/pharmacy/${pharmacyId}/services/${serviceId}`, details),
    nationalHolidays: () => getRequest(`${apiConfig.base_url}/web/pharmacy/holidays`),
    searchPatientsList: (pharmacyId, data = {}) => {
        let getString = '';

        if (data.searchBy !== undefined && data.searchString !== undefined) {
            getString += `?searchBy=${data.searchBy}&string=${data.searchString}`;
        }
        if (data.orderBy !== undefined) {
            getString += `&sort_by=${data.orderBy}`;
        }
        if (data.offset !== undefined && data.limit !== undefined) {
            getString += `&offset=${data.offset}&limit=${data.limit}`
        }
        if (data.modal !== undefined) {
            getString += `&modal=${data.modal}`;
        }
        return getRequest(`${apiConfig.base_url}/web/pharmacy/${pharmacyId}/search-patients${getString}`)
    },
    
    getPatientsWhiteList: (pharmacyId, data = {}) => {
        let getString = '';
        if (data.orderBy !== undefined) {
            getString += `?sort_by=${data.orderBy}`;
        }
        if (data.offset !== undefined && data.limit !== undefined) {
            getString += `&offset=${data.offset}&limit=${data.limit}`
        }
        return getRequest(`${apiConfig.base_url}/web/pharmacy/${pharmacyId}/patients${getString}`)
    },
    editWhiteList: (details, pharmacyId) =>  postRequest(`${apiConfig.base_url}/web/pharmacy/${pharmacyId}/patients`, details),

    getPatientsWhiteListCourier: (pharmacyId, data = {}) => {
        let getString = '';
        if (data.orderBy !== undefined) {
            getString += `?sort_by=${data.orderBy}`;
        }
        if (data.offset !== undefined && data.limit !== undefined) {
            getString += `&offset=${data.offset}&limit=${data.limit}`
        }
        return getRequest(`${apiConfig.base_url}/web/pharmacy/${pharmacyId}/patients-courier${getString}`)
    },
    editWhiteListCourier: (details, pharmacyId) =>  postRequest(`${apiConfig.base_url}/web/pharmacy/${pharmacyId}/patients-courier`, details)
});


// WEBPACK FOOTER //
// ./src/customModules/Common/rest-api/api-pharmacies.js